"use client";
import CTA from "@/components/CTA";
import CTALink from "@/components/CTA/ctaLink";
import { ElementType } from "@/constants/tagular/main";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";
import { DegreeDetailRedesignTestResult } from "@/monarch/rules/degreeDetailRedesignTraffic/types";
import type { CTA as CTAType } from "@/types";

type DegreeCTAProps = {
  title: string;
  cta: CTAType | null;
  locationRestrictions?: {
    allowedIn: string[];
    blockedIn: string[];
  };
  location?: string;
  html_id?: string;
};

const DegreeCTA = (props: DegreeCTAProps) => {
  return (
    <MonarchDataConsumer<DegreeDetailRedesignTestResult>
      experimentKey="useDegreeDetailRedesignTraffic"
      render={({ data }) => {
        if (data?.endPageCta?.hide) {
          return null;
        }
        return (
          <div className="container">
            <CTA
              theme="light"
              title={
                data?.endPageCta?.hideTitle
                  ? ""
                  : (data?.endPageCta?.title ?? props.title)
              }
              variant="banner"
              titleSize="default"
              emphasizeTitle
              locationRestrictions={props.locationRestrictions}
            >
              {!data?.endPageCta?.hideButton && (
                <CTALink
                  label={data?.endPageCta?.text ?? props.cta?.label ?? ""}
                  size="xl"
                  type="brand"
                  icon="arrow-right"
                  url={data?.endPageCta?.url ?? props.cta?.url ?? ""}
                  location={props.location}
                  html_id={props.html_id}
                  elementType={ElementType.Button}
                />
              )}
            </CTA>
          </div>
        );
      }}
    />
  );
};

export default DegreeCTA;
